/** Palette offered for packs and hotel rooms; values are theme tokens, not hex. */
export const ENTITY_COLORS = ["orange", "amber", "blue", "purple", "green"] as const;

export type EntityColor = (typeof ENTITY_COLORS)[number];

const COLOR_CLASS: Record<string, string> = {
  orange: "bg-akuna-orange",
  amber: "bg-akuna-amber",
  blue: "bg-akuna-blue",
  purple: "bg-akuna-purple",
  green: "bg-state-success",
};

export const colorDotClass = (color: string | null) => COLOR_CLASS[color ?? ""] ?? "bg-color-light";
export const colorBarClass = (color: string | null) => COLOR_CLASS[color ?? ""] ?? "bg-color-light";
export const colorDotStyle = (color: string | null): { backgroundColor?: string } =>
  color && /^#[0-9a-f]{6}$/i.test(color) ? { backgroundColor: color } : {};
